import { PropsWithChildren, useEffect, useMemo, useState } from "react";
import {
  InternationalizationContext,
  Language,
} from "./InternationalizationContext";

const languageStorageKey = "language";

const parseLanguage = (languageTag: string | null): Language | undefined => {
  switch (languageTag?.split("-")[0].toLowerCase()) {
    case "de":
      return "DE";
    case "en":
      return "EN";
    default:
      return undefined;
  }
};

const initialLanguage = (): Language =>
  parseLanguage(localStorage.getItem(languageStorageKey)) ??
  navigator.languages.map(parseLanguage).find(Boolean) ??
  "EN";

export const InternationalizationProvider = ({
  children,
}: PropsWithChildren) => {
  const [language, setLanguage] = useState(initialLanguage);

  const contextValue = useMemo(
    () => ({
      language,
      setLanguage: (chosenLanguage: Language) => {
        localStorage.setItem(languageStorageKey, chosenLanguage);
        setLanguage(chosenLanguage);
      },
    }),
    [language],
  );

  // Screen readers pick their pronunciation from the page language.
  useEffect(() => {
    document.documentElement.lang = language.toLowerCase();
  }, [language]);

  return (
    <InternationalizationContext.Provider value={contextValue}>
      {children}
    </InternationalizationContext.Provider>
  );
};
